import { OptionType } from '@evinced-private/ui-common';

import { addLabels } from 'src/apps/web-sdks/services/api/LabelUpdateApiService';
import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';
import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

export const handleSave = async (
	testRows: IWebSdkTest[],
	additions: Array<{ labelType: OptionType; value: OptionType }>,
	onClose: () => void,
	tenantConfiguredLabels?: ConfigurationLabel[],
	onSaveSuccess?: () => void
): Promise<void> => {
	if (additions.length === 0 || testRows.length === 0) {
		onClose();
		return;
	}

	await addLabels(testRows, additions, tenantConfiguredLabels);
	onSaveSuccess?.();
	onClose();
};
